import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { DataFieldEditBase } from '../data-field-edit-base';

@Component({
    selector: 'data-field-edit-custom-numeric',
    templateUrl: './custom-numeric.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'data-field-edit-custom-numeric' },
    standalone: false,
})
export class DataFieldEditCustomNumericComponent extends DataFieldEditBase {}
